import { css } from 'aphrodite';
import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '../../../components-v2/Button';
import { Skeleton } from '../../../components-v2/Skeleton';
import { styleSheet } from './styles';

export const AgentPanelItem: FC<{
	action?: ReactNode;
	detail?: string;
	lead?: ReactNode;
	meta?: string;
	title: string;
}> = ({ action, detail, lead, meta, title }) => (
	<div className={css(styleSheet.panelItem)}>
		{lead ? <div className={css(styleSheet.panelItemLead)}>{lead}</div> : null}
		<div className={css(styleSheet.panelItemBody)}>
			<span className={css(styleSheet.panelItemTitle)}>
				{title}
				{meta ? <span className={css(styleSheet.panelItemMeta)}>{` · ${meta}`}</span> : null}
			</span>
			{detail ? <span className={css(styleSheet.panelItemDetail)}>{detail}</span> : null}
		</div>
		{action}
	</div>
);

export const AgentPanelMessage: FC<{ action?: ReactNode; children: ReactNode }> = ({ action, children }) => (
	<div className={css(styleSheet.panelMessage)}>
		<p className={css(styleSheet.panelMessageText)}>{children}</p>
		{action}
	</div>
);

export const AgentPanelFooter: FC<{ children: ReactNode }> = ({ children }) => (
	<div className={css(styleSheet.panelFooter)}>{children}</div>
);

export const AgentPanelLink: FC<{ children: ReactNode; onClick?: () => void; to: string }> = ({
	children,
	onClick,
	to,
}) => (
	<Button variant='link' size='sm' styles={[styleSheet.footerLink]} asChild>
		<NavLink to={to} onClick={onClick}>
			{children}
		</NavLink>
	</Button>
);

export const AgentPanelSkeleton: FC = () => (
	<>
		<Skeleton styles={[styleSheet.panelSkeletonRow]} />
		<Skeleton styles={[styleSheet.panelSkeletonRow]} />
	</>
);
